export const PAGE_URL_THANK_YOU = '/thank-you'
export const API_URL_SEARCH_CITIES = '/api/search-cities'
export const API_URL_SEARCH_ZONES = '/api/search-zones'
export const API_URL_GET_FORM_DATA = '/api/get-form-data'
export const API_URL_SUBMIT_FORM = '/api/submit-form'
